import { Truck, ShieldCheck, MessageCircle } from "lucide-react";
import { useLanguage } from "@/context/LanguageContext";

export default function FeaturesBar() {
  const { t } = useLanguage();
  const FEATURES = [
    { icon: Truck, title: t("feat_ship_t"), sub: t("feat_ship_s") },
    { icon: ShieldCheck, title: t("feat_pay_t"), sub: t("feat_pay_s") },
    { icon: MessageCircle, title: t("feat_wa_t"), sub: t("feat_wa_s") },
  ];
  return (
    <section data-testid="features-bar" className="px-4 py-4 lg:px-8">
      <div className="mx-auto grid max-w-7xl grid-cols-1 gap-3 sm:grid-cols-3">
        {FEATURES.map((f, i) => (
          <div
            key={i}
            data-testid={`feature-item-${i}`}
            className="flex items-center gap-3 rounded-lg border border-line bg-white px-4 py-3.5"
          >
            <span className="flex h-10 w-10 shrink-0 items-center justify-center rounded-full bg-brand text-brandink">
              <f.icon className="h-5 w-5" />
            </span>
            <div>
              <p className="text-sm font-bold text-brandink">{f.title}</p>
              <p className="text-xs text-muted">{f.sub}</p>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
}
